import { Box } from '@mui/material';

const EmptyStateValidation = ({ message}) => {
  return (
    <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100%',
        width: '100%',
        p: 2
    }}>
      {message}
    </Box>
  );
};

export default EmptyStateValidation;